import { createFileRoute } from "@tanstack/react-router";

import { createHead } from "@/components/createHead";
import MarketingFooter from "@/components/MarketingFooter";
import { MarketingNavBar } from "@/components/MarketingNavBar";
import { Picture } from "@/components/Picture";
import { StickyNav } from "@/components/StickyNav";
import { ButtonAnchor, ButtonLink } from "@/components/ui/button";
import coneImg from "@/images/cone.webp?w=500;900;1200&format=avif;webp;jpg&as=picture";
/* eslint-disable import-x/no-duplicates */
// @ts-expect-error TODO: fix this
import heroIllustration from "@/images/illustration.png?slice=1&height=1200&width=1200&x=600&y=931";
// @ts-expect-error TODO: fix this
import card3 from "@/images/illustration.png?slice=1&height=221&width=506&x=1477&y=2255";
// @ts-expect-error TODO: fix this
import card2 from "@/images/illustration.png?slice=1&height=221&width=506&x=352&y=488";
// @ts-expect-error TODO: fix this
import card1 from "@/images/illustration.png?slice=1&height=221&width=506&x=883&y=2310";
/* eslint-enable import-x/no-duplicates */
import pollenImg from "@/images/pollen.png?w=500;900;1200&format=avif;webp;jpg&as=picture";

export const Route = createFileRoute("/advertising")({
  component: RouteComponent,
  head: ({ match: { pathname } }) =>
    createHead({
      title: "Advertising | Graze",
      description: "Advertise on Bluesky Feeds with Graze",
      ogTitle: "Advertising | Graze",
      pathname,
      ogImage: "/advertising.png",
    }),
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-slate-app instrument-sans text-slate-normal">
      <header className="bg-orange-9 dark:bg-orangedark-9 text-orange-contrast dark:text-orangedark-contrast">
        <div className="flex items-center gap-12 mx-auto container px-4">
          <div className="h-full items-center justify-center hidden md:flex flex-1 @container">
            <div className="relative flex items-center justify-center">
              <div
                className="sharp-grotesk text-[100cqw] leading-[0.9] big-g-scroll"
                style={{
                  backgroundImage: `url('${heroIllustration}')`,
                  backgroundSize: "200cqw",
                  backgroundPosition: "173cqw 527cqw",
                  backgroundClip: "text",
                  color: "transparent",
                  textShadow: "none",
                }}
              >
                G
              </div>
              <div className="absolute right-[4.5cqw] bottom-[5cqw] text-slate-12 instrument-serif text-[15cqw] italic">
                Graze
              </div>
            </div>
          </div>
          <div className="flex-1 py-6 md:py-10 flex flex-col @container">
            <div className="flex mb-2 md:mb-16 md:justify-end sticky top-[-100%]">
              <MarketingNavBar onlyNav variant="light" />
            </div>
            <h1 className="text-[14cqw] instrument-serif bold mb-8 leading-none">
              The Only Way to Advertise on Bluesky
            </h1>
            <div className="mb-6 md:mb-8 flex flex-col gap-4 max-w-[68ch] border-2 border-orange-11 dark:border-orangedark-11 rounded-xl p-4 bg-white/30 dark:bg-black/30">
              <p className="text-xl md:text-2xl font-medium">
                Show up with intention and connect directly with your audience
                on a whole new generation of open-protocol social apps.
              </p>
            </div>
          </div>
        </div>
      </header>

      <StickyNav variant="orange" />

      <section className="py-6 md:py-16">
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            Why brands choose Graze
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card1}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Escape algorithm roulette
                </div>
                <div className="text-lg">
                  Your content appears in feeds people actually want to see
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card2}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Own your attribution
                </div>
                <div className="text-lg">
                  Every click drives directly to your properties, no platform
                  middleman
                </div>
              </div>
            </div>
            <div className="flex flex-col border-slate-7 dark:border-slatedark-7 hover:border-slate-9 hover:dark:border-slatedark-9 eoverflow-hidden border-2 rounded-lg">
              <div
                className="h-[150px] md:h-[200px] bg-cover bg-center bg-no-repeat"
                style={{
                  backgroundImage: `url('${card3}')`,
                }}
              ></div>
              <div className="p-4 md:p-8 flex flex-col gap-2 border-t border-slate-7 dark:border-slatedark-7">
                <div className="text-3xl md:text-4xl font-bold instrument-serif">
                  Reach early adopters
                </div>
                <div className="text-lg">
                  Connect with influential users shaping conversations in your
                  industry
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 bg-orange-4 dark:bg-orangedark-4">
        <div className="container @container mx-auto grid relative z-0 px-4">
          <div
            className="flex flex-col justify-center items-center lg:container mx-auto gap-4 bg-position-[-11cqw_-314cqw]"
            style={{
              textShadow: "0 0 0 rgba(255, 255, 255, 0.1)",
            }}
          >
            <div className="leading-relaxed instrument-serif w-full text-[4cqw] md:text-[3.2cqw] text-center">
              With over 1.6M+ monetized pageviews per day and 400K+ monetized
              readers,
              <br />
              Graze delivers proven reach at scale.
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-slate-3 dark:bg-slatedark-3">
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-16">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
            Real Results
          </h2>
          <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
            <div className="flex-1 flex flex-col gap-10">
              <p className="text-xl md:text-3xl max-w-[68ch] leading-relaxed">
                Sill had a great social news product with no way to reach future
                customers. Graze's sponsored content market connected them
                directly to their ideal audience on the Verified News feed,
                delivering ridiculously effective results.
              </p>
              <div className="flex items-center gap-2 md:gap-4">
                <div className="text-lg font-semibold p-4 border-2 border-green-7 dark:border-greendark-7 rounded-lg bg-green-3 dark:bg-greendark-3 text-green-normal">
                  $100 spend
                </div>
                <div className="text-lg font-semibold">→</div>
                <div className="text-lg font-semibold p-4 border-2 border-yellow-7 dark:border-yellowdark-7 rounded-lg bg-yellow-3 dark:bg-yellowdark-3 text-yellow-normal">
                  37.5k users reached
                </div>
                <div className="text-lg font-semibold">→</div>
                <div className="text-lg font-semibold p-4 border-2 border-red-7 dark:border-reddark-7 rounded-lg bg-red-3 dark:bg-reddark-3 text-red-normal">
                  50 customers acquired
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-4 shrink-0 flex-1">
              <div className="shrink-0 md:flex-1 flex items-center bg-orange-10 dark:bg-orangedark-10 text-orange-contrast dark:text-orangedark-contrast @ border-2 border-orange-11 dark:border-orangedark-11 rounded-lg @container">
                <div className="p-8 flex flex-col items-end gap-8">
                  <div className="flex items-center md:items-start gap-8">
                    <div className="shrink-0 h-[100px] w-[100px]">
                      <img
                        src="https://cdn.bsky.app/img/avatar/plain/did:plc:ryed5tnzwmpwbidrsuwrlwwb/bafkreige3zwrdpnsuqaualn5l5yfa2kf7a3goebrwyetwwq6srfcjjgpxa@jpeg"
                        alt=""
                        className="h-full w-full rounded-full border-2"
                      />
                    </div>
                    <div className="text-lg md:text-xl leading-relaxed">
                      Thanks to Graze, I was able to advertise my app, Sill,
                      directly to my target audience: news readers on Bluesky.
                      All in all, Graze rewires the relationship between
                      advertiser and host on social media. It's a bold vision
                      that helps a burgeoning decentralized network support
                      itself.
                    </div>
                  </div>
                  <div className="text-lg md:text-xl instrument-serif">
                    ~ Tyler Fisher, CEO,{" "}
                    <a
                      href="https://sill.social/"
                      className="underline decoration-wavy underline-offset-8 hover:decoration-solid"
                    >
                      Sill
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-6 md:py-16 bg-yellow-slate-3 dark:bg-yellow-slatedark-3 relative">
        <div className="container mx-auto p-4 md:px-12 flex flex-col md:flex-row gap-8 md:gap-16">
          <div className="flex flex-col gap-8 md:gap-16">
            <h2 className="text-4xl md:text-6xl font-bold instrument-serif">
              How It Works
            </h2>
            <ol className="flex flex-col gap-4 text-lg md:text-xl list-decimal ml-8">
              <li className="pl-2">
                <span className="font-semibold">Partner with us</span> to build
                creative and identify the right communities
              </li>
              <li className="pl-2">
                <span className="font-semibold">Launch your campaign</span> in
                relevant, opt-in feeds where audiences actually want to see your
                content
              </li>
              <li className="pl-2">
                <span className="font-semibold">Track performance</span> in real
                time and adjust as you go
              </li>
              <li className="pl-2">
                <span className="font-semibold">Drive traffic directly</span> to
                your owned properties with full attribution
              </li>
            </ol>
            <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed">
              Whether you're running a standard campaign or building a branded
              feed around a big moment, we'll help you reach the right audiences
              in spaces they've chosen to be part of.
            </p>
          </div>
          <div className="absolute top-4 right-4 md:relative flex items-center justify-center w-[24px] md:w-[25%]">
            <Picture src={coneImg} alt="" />
          </div>
        </div>
      </section>
      <section className="py-6 md:py-16 bg-orange-9 dark:bg-orangedark-9 text-orange-contrast dark:text-orangedark-contrast relative">
        <div className="absolute top-8 md:top-6 xl:top-12 left-6 flex items-center justify-center w-[80px] md:w-[10%] z-0">
          <Picture src={pollenImg} alt="" />
        </div>
        <div className="container mx-auto p-4 md:px-12 flex flex-col gap-8 md:gap-12 relative z-1">
          <h2 className="text-4xl md:text-6xl font-bold instrument-serif text-center text-shadow-lg md: max-w-[60vw] mx-auto leading-tight">
            Ready to be the first brand in your space on Bluesky and ATProto?
          </h2>
          <p className="text-lg md:text-xl max-w-[80ch] leading-relaxed mx-auto">
            Engaged communities are building the future of social media on
            ATProto—and traditional ad platforms can't reach them. Custom feeds
            give you the space to show up with intention in communities built
            around shared interests and values, not algorithmic guesswork.
          </p>
          <div className="flex gap-4 justify-center">
            <ButtonAnchor
              href="mailto:admin@graze.social"
              className="text-orange-normal"
              variant="outline"
            >
              Talk to our team
            </ButtonAnchor>
            <ButtonLink to="/ads">Get Started</ButtonLink>
          </div>
        </div>
      </section>
      <MarketingFooter showStartSection={false} />
    </div>
  );
}
